const fallback = 'We couldn’t complete this just now. Please try again in a moment.';
export function friendlyMessage(value, defaultMessage = fallback) {
  const message = typeof value === 'string' ? value.trim() : '';
  if (!message || message.length > 260 || /\b(sql|mysql|sequelize|axios|exception|undefined|null|stack|errno|econn\w*|enotfound|internal server|unknown error|network error|request failed|status code|syntaxerror|typeerror)\b|<[^>]+>|\bat\s+\w+\s*\(/i.test(message)) return defaultMessage;
  if (/^(error|an error|something went wrong)/i.test(message)) return defaultMessage;
  if (/^failed to /i.test(message)) return message.replace(/^Failed to /i, 'We couldn’t ').replace(/\.$/, '') + (/try again/i.test(message) ? '' : '. Please try again.');
  return message;
}
